// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1OnuR","col":"Table_col__2QO1d","fulfillmentStatus":"Table_fulfillmentStatus__3syS8","emailCol":"Table_emailCol__3wTy0"};